import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = (props: { fontFamily?: string; inputControl?: string }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      membershipMainBlock: {
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '100%'
      },
      membershipContainer: {
        background: 'white',
        height: '794px',
        borderRadius: '8px',
        overflow: 'hidden',
        width: '100%',
        boxShadow: '0 3px 9px 0px rgba(0,0,0,0.2)',
        [theme.breakpoints.down('lg')]: {
          height: '1630px',
          flexDirection: 'column-reverse'
        }
      },
      subHeading: {
        fontSize: '25px',
        [theme.breakpoints.down('lg')]: {
          fontSize: '30px'
        }
      },
      imageContainer: {
        [theme.breakpoints.down('lg')]: {
          marginBottom: '40px'
        }
      },
      scanTextContainer: {
        [theme.breakpoints.down('lg')]: {
          padding: '40px 134px 60px 134px',
          height: '55%'
        },
        margin: 0,
        padding: '120px 60px 60px 160px',
        background: 'transparent'
      },
      memberNotFoundTitle: {
        background: 'transparent',
        width: '720px',
        fontSize: '52px',
        fontWeight: 600,
        textAlign: 'center',
        lineHeight: 1,
        fontFamily: props.fontFamily,
        [theme.breakpoints.down('lg')]: {
          width: '610px',
          fontSize: '64px'
        }
      },
      memberNotFoundDescription: {
        margin: '0px 0px 36px 0px',
        background: 'transparent',
        width: '810px',
        fontSize: '30px',
        textAlign: 'center',
        fontFamily: props.fontFamily,
        [theme.breakpoints.down('lg')]: {
          width: '720px',
          lineHeight: 1.53
        }
      },
      selectionCardContainer: {
        justifyContent: 'space-around',
        background: 'transparent',
        marginBottom: '20px',
        [theme.breakpoints.down('lg')]: {
          gap: '25px',
          paddingTop: '25px',
          minHeight: '1300px',
          alignItems: 'center'
        }
      },
      customSearchOuterContainer: {
        height: '809px',
        padding: '0 24px 24px',
        [theme.breakpoints.down('lg')]: {
          height: '1660px'
        }
      },
      customSearchInnerContainer: {
        background: 'white',
        padding: '30px 64px',
        [theme.breakpoints.down('lg')]: {
          height: '1600px',
          padding: '98px 30px 48px 30px'
        }
      },
      customSearchInputsBox: {
        flex: '1 1 0%',
        background: 'transparent',
        [theme.breakpoints.down('lg')]: {
          height: '1000px'
        }
      },
      customSearchInputsContainer: {
        padding: '0px 80px 0px 80px',
        height: props.inputControl ? '220px' : '525px',
        [theme.breakpoints.down('lg')]: {
          height: '100%',
          padding: '0px 0px 0px 0px'
        }
      },
      customSearchInputField: {
        [theme.breakpoints.down('lg')]: {
          minWidth: '350px !important',
          fontSize: '30px'
        }
      },
      footerContainer: {
        margin: '20px -24px 0',
        paddingTop: '22px',
        width: 'calc(100% + 48px)',
        [theme.breakpoints.down('lg')]: {
          paddingTop: '24px'
        }
      }
    })
  );
